
import productAPI from "../../api/productAPI";
export async function getProductList() {
    try {
        const { data: listProduct } = await productAPI.getListProduct()
        return listProduct;
    } catch (error) {
        throw new Error(error)
    }
}